"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Styles = exports.CSS = void 0;
exports.CSS = {
    container: 'c-AutoCompleteMenu',
    item: 'c-AutoCompleteMenu__Item',
    highlighted: 'c-AutoCompleteMenu--Highlighted'
};
exports.Styles = (_a = {},
    _a[exports.CSS.highlighted] = {
        'font-weight': 'bold'
    },
    _a);
//# sourceMappingURL=autocomplete.menu.style.js.map